module.exports = __webpack_public_path__ + "img/baogaoshurumokuaitubiao-.7b369c0c.png";